import React from 'react';

const OrderConfirmationPageHero = () => (
  <div className="OrderConfirmationPageHero" />
);

OrderConfirmationPageHero.propTypes = {};

export default OrderConfirmationPageHero;
